const CLOUD_FUNCTION_NAME = "proposalCICLRequested";

export const requestPolicyProposal = ({ checkout, documentId, firebase, offer, quoteForm }): void =>
  firebase.functions.httpsCallable(CLOUD_FUNCTION_NAME)({
    funnelId: documentId,
    funnel: {
      checkout,
      offer,
      quoteForm
    }
  });
